import * as React from 'react'
export const useRefDom = <A extends HTMLElement>(): [React.RefObject<A>, A | null] => {
  const ref = React.useRef<A>( null )
  const [ refDom, setRefDom ] = React.useState<A | null>( null )
  React.useEffect( () => {
    if ( ref.current !== null ) { setRefDom( ref.current as A ) }
  }, [] )
  return [ ref, refDom as A | null ]
}
